export interface DSAlgorithm {
  name: string;
  value: number;
}

const DSALGORITHMS: DSAlgorithm[] = [
  {name: 'DSA', value: 3},
  {name: 'RSASHA1', value: 5},
  {name: 'DSA-NSEC3-SHA1', value: 6},
  {name: 'RSASHA1-NSEC3-SHA1', value: 7},
  {name: 'RSASHA256', value: 8},
  {name: 'RSASHA512', value: 10},
  {name: 'ECC-GOST', value: 12},
  {name: 'ECDSAP256SHA256', value: 13},
  {name: 'ECDSAP384SHA384', value: 14},
  {name: 'ED25519', value: 15},
  {name: 'ED448', value: 16},
];

export { DSALGORITHMS }
